import PersonalArea from './PersonalArea';

export default PersonalArea;
